import React from 'react';
import ContactForm from '../components/ContactForm';

const Contact = () => {
    return (
        <div>
            <h1 style={{ textAlign: 'center', marginTop: '40px' }}>Contact Me</h1>
            <ContactForm />
        </div>
    );
};

export default Contact;
